export const derashEndpoints = {
  billers: "derashApp/services/listDerashBillers",
  paymentQuery: "derashApp/services/searchDerashPnr",
  payment: "derashApp/services/payDerashPayment",
};

export const derashConst = [
  {
    title: "Derash Payment",
    labels: [
      "Select Account Number",
      "Biller",
      "Enter PNR",
      "Enter Phone Number",
      "Search",
      "Bill ID",
      "Amount",
      "Customer Name",
      "Due Date",
      "Bill Description",
      "Continue",
    ],
    billersTitle: "Select Biller",
    confirmationTitle: "Confirm Derash payment",
  },
  {
    title: "የDerash ክፍያ",
    labels: ["የሂሳብ ቁጥር ይምረጡ", "አከፋፋይ", "PNR ያስገቡ", "ስልክ ቁጥር ያስገቡ", "ፈልግ", "የክፍያ መለያ", "መጠን", "የደንበኛ ስም", "የመክፈያ ቀን", "የክፍያ መግለጫ", "ቀጥል"],
    billersTitle: "አከፋፋይ ይምረጡ",
    confirmationTitle: "የDerash ክፍያን ያረጋግጡ",
  },
  {
    title: "Kaffaltii Derash",
    labels: ["Lakkoofsa Herregaa Filadhu", "Kaffalaa", "PNR Galchi", "Lakkoofsa Bilbilaa Galchi", "Barbaadi", "Bill ID", "Baay'ina", "Maqaa Maamilaa", "Guyyaa Xumuraa", "Ibsa Billii", "Itti Fufi"],
    billersTitle: "Kaffalaa Filadhu",
    confirmationTitle: "Kaffaltii Derash mirkaneessi",
  },
  {
    title: "ክፍሊት Derash",
    labels: ["ቁጽሪ ሕሳብ ምረጽ", "ኣከፋፋሊ", "PNR ኣእትው", "ቁጽሪ ተሌፎን ኣእትው", "ድለ", "Bill ID", "መጠን", "ስም ዓሚል", "ዕለት መኽፈሊ", "መግለጺ Bill", "ቀጽል"],
    billersTitle: "ኣከፋፋሊ ምረጽ",
    confirmationTitle: "ክፍሊት Derash ኣረጋግጽ",
  },
  {
    title: "Bixinta Derash",
    labels: ["Xisaab Nambarka Dooro", "Bixiyaha", "Geli PNR", "Geli Lambarka Taleefanka", "Raadi", "Bill ID", "Qadarka", "Magaca Macmiilka", "Taariikhda Bixinta", "Sharaxaada Bill-ka", "Sii Soco"],
    billersTitle: "Dooro Bixiyaha",
    confirmationTitle: "Xaqiiji bixinta Derash",
  },
  {
    title: "Derash Mekla",
    labels: ["Hisab Nummara Yokale", "Meklayta", "PNR Culusa", "Telefoon Nummara Culusa", "Gexso", "Bill ID", "Qadaana", "Migaq Rabi", "Addat Qadaana", "Bill Baxxaq", "Itteh"],
    billersTitle: "Meklayta Yokale",
    confirmationTitle: "Derash mekla asmatis",
  },
];
